import React, { useEffect } from "react";

function LetterSeparator(props: any) {
  return (
    <>
      <span style={{ display: "inline-block" }} className="letterSpan__con">
        {props.word.split("").map((letter: string, letterIndex: number) => (
          <span>{letter}</span>
        ))}
      </span>
    </>
  );
}
export default function TitleYear(props: any) {
  return (
    <div className="titleYear__con" data-scroll data-scroll-speed={-2}>
      <LetterSeparator word={props.word} />
    </div>
  );
}
